export default __webpack_public_path__ + "static/Aggie-23349ff3a6671d909a75de6199d5a1e1.jpg";